import axios, { AUTH_PREFIX } from 'src/clients/axios';
import {
  RegisterChildSubmitData,
  RegisterChildSubmitResponse,
} from 'src/pages/MultiAccount/type';

export const registerChildUser = (data: RegisterChildSubmitData) => {
  return axios.request<RegisterChildSubmitResponse>({
    url: `${AUTH_PREFIX}/account/multi-account/registration`,
    method: 'post',
    data,
  });
};

type RegisterChildSubmitDataV2 = {
  brand_name: string;
  full_name: string;
  username: string;
  phone_number?: string | null;
  email: string;
  child_type: string;
  is_copy_data: boolean;
};

export const registerChildUserV2 = (data: RegisterChildSubmitDataV2) => {
  return axios.request<RegisterChildSubmitResponse>({
    url: `${AUTH_PREFIX}/account/multi-account/registration`,
    method: 'post',
    data,
  });
};
